/* eslint-disable @angular-eslint/prefer-standalone */
import { Component } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-loader',
    template: `
      <ngx-spinner
        bdColor="rgba(255, 255, 255, 0.5)"
        size="large"
        color="#041e42"
        type="ball-scale-multiple"
        [fullScreen]="true">
        <p style="color: #041e42; font-size: 18px; font-weight: 600; margin-top: 100px;">
          Carregando...
        </p>
      </ngx-spinner>
    `,
    standalone: false
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) { }
}
